export const tomos = [
  {
    numeral: 'I',
    title: 'Mente Consciente',
    description:
      'Ruido mental, cortisol crónico y el Protocolo de Anclaje Mental de 15 minutos diarios que cambia el estado por defecto.',
    icon: 'brain',
  },
  {
    numeral: 'II',
    title: 'Arquitectura del Sueño',
    description:
      'La ciencia del sueño profundo aplicada al contexto argentino. Protocolo nocturno completo y gestión estratégica de la cafeína.',
    icon: 'moon',
  },
  {
    numeral: 'III',
    title: 'Hábitos de Hierro',
    description:
      'Los 3 Hábitos de Hierro con Habit Stacking. Cómo instalar lo que importa sin depender de la motivación.',
    icon: 'dumbbell',
  },
  {
    numeral: 'IV',
    title: 'Energía y Nutrición',
    description:
      'El ciclo glucémico y el protocolo de alimentación para el presupuesto argentino real. Sin dietas. Sin suplementos caros.',
    icon: 'salad',
  },
  {
    numeral: 'V',
    title: 'Organización 360',
    description:
      'El Diseño Semanal, el sistema de 3 listas y el Vaciado Mental. El Cuadrante II protegido antes de que lleguen las urgencias.',
    icon: 'calendar',
  },
  {
    numeral: 'VI',
    title: 'Propósito y Resiliencia',
    description:
      'Valores centrales, Visión de Vida a 10 años y resiliencia real en contexto de incertidumbre argentina.',
    icon: 'compass',
  },
] as const;

export const tomoIncluye = [
  'Protocolos paso a paso listos para implementar',
  'Versión mínima para semanas de alta presión',
  'Actividades, checklists y rastreadores',
  'Adaptado 100% al contexto argentino 2025',
];

export const bonos = [
  {
    numero: '01',
    title: 'El Diario de los 21 Días',
    description: 'Registro diario con seguimiento pilar a pilar.',
    valor: '$8.900',
  },
  {
    numero: '02',
    title: 'Guía de Nutrición Real para Argentina',
    description: 'Comer bien con lo que hay, al precio que hay.',
    valor: '$9.900',
  },
  {
    numero: '03',
    title: 'El Protocolo de Emergencia',
    description: 'Qué hacer exactamente cuando todo explota.',
    valor: '$8.900',
  },
  {
    numero: '04',
    title: 'El Mapa de Claridad Personal',
    description: 'Valores, visión y objetivos de los próximos 12 meses.',
    valor: '$9.900',
  },
  {
    numero: '05',
    title: 'El Manual de Sueño Profundo',
    description: 'Diagnóstico, entorno, protocolo y rastreador de 4 semanas.',
    valor: '$8.900',
  },
  {
    numero: '06',
    title: 'El Planificador Semanal y Mensual',
    description: 'Diseño Semanal, MIT diario y revisión mensual.',
    valor: '$7.100',
  },
];

export const dolores = [
  'La semana "se fue sola" sin avanzar en lo que importa.',
  'Dormís mal pero no sabés exactamente qué cambiar.',
  'Hábitos que duran 3 días y el mismo ciclo de culpa y reinicio.',
  'Energía irregular: café para arrancar, bajón a las 3 PM, nada para la noche.',
  'La cabeza llena de pendientes que dan vueltas cuando querés descansar.',
  'Planes que no se ejecutan, semanas sin dirección, el tiempo te usa a vos.',
];

export const testimoniosCortos = [
  {
    quote:
      'Dormía mal hace tres años. En dos semanas con el Manual de Sueño noté una diferencia brutal.',
    author: 'Roberto M.',
    city: 'Buenos Aires',
  },
  {
    quote:
      'Por primera vez tengo una rutina que se sostiene sola. El sistema funciona incluso en las semanas difíciles.',
    author: 'Lucas P.',
    city: 'Rosario',
  },
  {
    quote:
      'El bajón de las 3 PM prácticamente desapareció. Solo cambiando el orden de lo que como.',
    author: 'Diego M.',
    city: 'Tucumán',
  },
];

export const testimonios = [
  {
    quote:
      'El Master Plan de 90 días me sacó el agobio de no saber por dónde empezar. Por primera vez no estoy leyendo sobre cambiar. Estoy cambiando.',
    author: 'Cecilia R.',
    city: 'Mendoza',
    plan: 'Reset Integral + Workbook',
  },
  {
    quote:
      'Seis semanas con el sistema. Es la primera vez en años que duermo bien, tengo energía real y sé exactamente qué estoy haciendo con mi tiempo.',
    author: 'Sofía C.',
    city: 'La Plata',
    plan: 'Reset Integral',
  },
  {
    quote:
      'El Protocolo de Emergencia me salvó en una semana de crisis laboral. Sin ese bono hubiera abandonado todo. Con él, retomé en 7 días.',
    author: 'Pablo A.',
    city: 'Neuquén',
    plan: 'Reset Integral',
  },
  {
    quote:
      'El Mapa de Claridad Personal me tomó dos tardes y fue la inversión más valiosa que hice en años. Por primera vez sé exactamente hacia dónde voy.',
    author: 'Verónica L.',
    city: 'Rosario',
    plan: 'Reset Integral + Workbook',
  },
];

export const workbookCompare = [
  {
    sin: '6 tomos pero sin saber por dónde empezar',
    con: 'Master Plan de 90 días con secuencia exacta semana a semana',
  },
  {
    sin: 'Implementación que depende de la motivación',
    con: 'Auditoría de Realidad que diagnostica tu punto de partida',
  },
  {
    sin: 'Pilares que funcionan por separado',
    con: 'Plantillas que integran todo en un solo sistema',
  },
  {
    sin: 'Sin saber si estás progresando',
    con: 'Rastreadores de progreso con comparación mes a mes',
  },
  {
    sin: 'Cuando el sistema falla, empezás de cero',
    con: 'Árbol de decisión del reinicio + Plan de Contingencia personal',
  },
];

export const faqs = [
  {
    q: '¿Funciona si ya intenté otros sistemas y fallaron?',
    a: 'Especialmente para vos. Los sistemas que fallaron no fallaron porque seas inconstante. Fallaron porque no estaban diseñados para el contexto argentino, no tenían protocolo de contingencia para las semanas difíciles y atacaban un solo pilar. Reset Integral tiene los 6 pilares integrados y un bono específico para las crisis.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con acceso a todos los PDFs. Menos de 5 minutos. Descargables, imprimibles, desde cualquier dispositivo.',
  },
  {
    q: '¿Requiere mucho tiempo?',
    a: 'El Protocolo de Anclaje lleva 15 minutos por día. El Diseño Semanal lleva 30-45 minutos los domingos. La planificación diaria lleva 5 minutos. Todo tiene una versión mínima para semanas de alta demanda.',
  },
  {
    q: '¿Funciona con estrés económico o laboral?',
    a: 'Fue diseñado exactamente para ese contexto. El Tomo I trata el ruido mental argentino de manera explícita. El Tomo IV incluye nutrición para presupuesto ajustado. El Bono 3 es un protocolo específico para semanas de crisis.',
  },
  {
    q: '¿Tiene garantía real?',
    a: '7 días, 100% de devolución, sin preguntas. Escribís a soporteatajodigital@gmail.com con tu comprobante. Sin formularios, sin demoras.',
  },
];

export const costos = [
  {
    sin: 'Sueño deteriorado todos los días',
    costo:
      'Decisiones de menor calidad, emociones más reactivas, salud deteriorada',
  },
  {
    sin: 'Sin sistema de hábitos',
    costo: 'Los domingos empezando el mismo ciclo año tras año',
  },
  {
    sin: 'Sin Diseño Semanal',
    costo: 'Lo urgente devora lo importante semana tras semana',
  },
  {
    sin: 'Sin claridad de valores',
    costo: 'Decisiones tomadas por presión externa, no por dirección propia',
  },
  {
    sin: 'Sin protocolo de emergencia',
    costo: 'Cada crisis borra todo lo construido y empezás de cero otra vez',
  },
];

export const planes = [
  {
    id: 'reset-integral',
    badge: null as string | null,
    kicker: 'AtajoDigital™',
    name: 'RESET INTEGRAL',
    includes: '6 Tomos + 6 Bonos',
    before: '$49.000',
    price: '$19.990',
    value: 19990,
    cta: 'Quiero mi Reset Integral',
    href: 'https://www.atajodigital.store/cart/52077930709313:1',
  },
  {
    id: 'workbook',
    badge: 'Más elegido',
    kicker: 'AtajoDigital™',
    name: 'RESET INTEGRAL + WORKBOOK',
    includes: '6 Tomos + 6 Bonos + Master Plan de 90 días',
    before: '$63.000',
    price: '$27.990',
    value: 27990,
    cta: 'Quiero el Reset Integral + Workbook',
    href: 'https://www.atajodigital.store/cart/52077937787201:1',
  },
];

export const PACKSHOT_URL =
  'https://cdn.magicpatterns.com/uploads/h1kepm4bJBAp9RmZLAWxPC/ChatGPT_Image_12_ago_2026,_10_55_31_p.m..png';
